import { Component, OnInit, ViewChild, ElementRef, Input, EventEmitter, Output, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { Picker } from '../picker';
import { FormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { SearchService } from '../../../../services/search.service';
import { log } from 'util';
@Component({
  selector: 'ts-airport-picker',
  templateUrl: './airport-picker.component.html',
  styleUrls: ['./airport-picker.component.scss', '../../style.scss']
})
export class AirportPickerComponent extends Picker implements OnInit, OnChanges {

  @Input() airports: any[];

  @ViewChild('searchInput') searchInput: ElementRef;
  @ViewChild('searchResultsWrapper') searchResultsWrapper: ElementRef;
  @ViewChild('searchResultsList') searchResultsListElement: ElementRef;
  @ViewChild('searchInputWrapper') searchInputWrapper: ElementRef;
  @Input() baseURL: any[];
  @Input() destinations: any[];
  @Input() searchedDestinations: any[];
  @Input() selectedAirport: string;
  @Input() country: string;
  @Output() airportSelected = new EventEmitter();
  @Output() enterClicked = new EventEmitter();

  resorts: any[];
  countries: any[];
  searchFormControl = new FormControl('');
  previousSearchValue = '';

  isTyping: Boolean = false;
  isDestination: Boolean = false;
  isHoverDisabled: Boolean = false;
  searchedDestinationFocusIndex: number = null;
  airport: string;
  withRefresh = false;
  hotelSearchResults$: Observable<any[]>;
  private hotelSearchText$ = new Subject<string>();



  constructor(private searchService: SearchService) {
    super();
  }


  ngOnInit() {
    this.airport = this.selectedAirport;
    this.searchedDestinations = [...this.airports];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedAirport) {
      this.airport = this.selectedAirport;
    }
  }

  incrementSearchedHotelsFocusIndex() {
    if (this.searchedDestinations.length > 0) {
      if (this.searchedDestinationFocusIndex === null) {
        this.setNextDestinationFocusInDropdown();
      } else {
        if (this.searchedDestinationFocusIndex < this.searchedDestinations.length - 1) {
          this.setNextDestinationFocusInDropdown();
        }
      }
    }
  }

  decrementSearcedHotelsFocusIndex() {
    if (this.searchedDestinations.length > 0) {
      if (this.searchedDestinationFocusIndex === null) {
        this.setPreviousDestinationFocusInDropdown();
      } else {
        if (this.searchedDestinationFocusIndex > 0) {
          this.setPreviousDestinationFocusInDropdown();
        }
      }
    }
  }

  private setNextDestinationFocusInDropdown() {
    let index = 1;
    if (this.searchedDestinationFocusIndex === null) {
      index = 0;
    }
    let nextDestinationInDropdown = this.searchedDestinations[this.searchedDestinationFocusIndex + index];
    if (nextDestinationInDropdown && (nextDestinationInDropdown.type === 'region' || nextDestinationInDropdown.type === 'airport')) {
      this.searchedDestinationFocusIndex = this.searchedDestinationFocusIndex + index;
    }
  }

  private setPreviousDestinationFocusInDropdown() {
    let index = 1;
    let previousDestinationInDropdown = this.searchedDestinations[this.searchedDestinationFocusIndex - index];
    if (previousDestinationInDropdown && (previousDestinationInDropdown.type === 'region' || previousDestinationInDropdown.type === 'airport')) {
      this.searchedDestinationFocusIndex = this.searchedDestinationFocusIndex - index;
    } else if (!previousDestinationInDropdown) {
      // If there is nothing to select, clear focus
      this.searchedDestinationFocusIndex = null;
      if (this.searchResultsListElement) {
        requestAnimationFrame(() => this.scrollToPosition(this.searchResultsListElement.nativeElement, 0, 'up'));
      }
    }
  }

  preventInputCaretMovement(event?: KeyboardEvent) {
    if (event && (event.keyCode === 40 || event.keyCode === 38 || event.keyCode === 13)) {
      event.preventDefault();
    }
  }

  search(event?: KeyboardEvent) {
    if (!this.searchFormControl.value) {
      this.reset();
    }
    if (event && (event.keyCode === 40 || event.keyCode === 38 || event.keyCode === 13)) {
      event.preventDefault();
      this.disableHover();
      // this.showDropdown = true;
    }
    if (event && event.keyCode === 40) {
      // If ArrowDown pressed
      if (this.searchedDestinationFocusIndex !== this.searchedDestinations.length - 1) {
        this.incrementSearchedHotelsFocusIndex();
        this.scrollToFocusedHotelItem('down');
      }
    } else if (event && event.keyCode === 38) {
      // If ArrowUp pressed
      if (this.searchedDestinationFocusIndex === null || this.searchedDestinationFocusIndex === 0) {
        this.searchedDestinationFocusIndex = null;
        this.searchInput.nativeElement.focus();
      } else {
        this.decrementSearcedHotelsFocusIndex();
        this.scrollToFocusedHotelItem('up');
      }
    } else if (event && event.keyCode === 13 && this.searchedDestinationFocusIndex !== null) {
      this.onDestinationClicked(this.searchedDestinations[this.searchedDestinationFocusIndex]);
    } else if (event && event.keyCode === 27) {
      // this.showDropdown = false;
    } else {
      if (this.searchFormControl.value !== this.previousSearchValue) {
        this.searchedDestinationFocusIndex = null;
        this.previousSearchValue = this.searchFormControl.value;
        this.sortSearch(this.searchFormControl.value);
      }
    }
  }

  sortSearch(value) {
    let searchedDestinations = [];
    let _destinations = [...this.airports];
    _destinations.forEach(airport => {
      // if (airport.type === 'airport') {
      if (airport.name.toLowerCase().includes(value.toLowerCase())) {
        searchedDestinations.push(airport);
      }
      // }
    });
    this.searchedDestinations = searchedDestinations;
  }


  onSelect() {
  }

  focus() {
    this.searchedDestinationFocusIndex = null;
  }

  enableHover() {
    this.isHoverDisabled = false;
  }

  disableHover() {
    this.isHoverDisabled = true;
  }

  setSearchedDestinationsFocusIndex(airport) {
    this.searchedDestinationFocusIndex = airport;
  }

  onMouseLeave() {
    this.enableHover();
    this.setSearchedDestinationsFocusIndex(null);
  }

  scrollToFocusedHotelItem(direction: 'up' | 'down') {
    setTimeout(() => {
      let searchResultsListElement = this.searchResultsListElement ? this.searchResultsListElement.nativeElement : null;
      if (!searchResultsListElement) {
        return;
      }
      // Get the focused hotel item
      const focusedHotelItem = searchResultsListElement.getElementsByClassName('focused') ? searchResultsListElement.getElementsByClassName('focused')[0] : null;
      if (focusedHotelItem) {
        const searchResultsWrapperElement = this.searchResultsWrapper.nativeElement;
        const searchResultsWrapperHeight = searchResultsWrapperElement.offsetHeight || searchResultsWrapperElement.clientHeight || searchResultsWrapperElement.scrollHeight;

        const scrollViewRangeTop = searchResultsWrapperElement.scrollTop;
        const scrollViewRangeBottom = searchResultsWrapperElement.scrollTop + searchResultsWrapperHeight;

        const focusedHotelItemBottomPosition = focusedHotelItem.offsetTop + focusedHotelItem.offsetHeight;
        const isFocusedHotelItemInView = (focusedHotelItem.offsetTop >= scrollViewRangeTop) && (focusedHotelItem.offsetTop < scrollViewRangeBottom) && (focusedHotelItemBottomPosition >= scrollViewRangeTop) && (focusedHotelItemBottomPosition < scrollViewRangeBottom);
        if (!isFocusedHotelItemInView) {
          /**
           * If the focusedHotelItem is not in view, determine where list should be scrolled to
           */
          let scrollToPositionValue = 0;
          if (this.searchedDestinationFocusIndex === this.searchedDestinations.length - 1) {
            // If focusedHotelItem is the last item, scroll to the max point
            const maxScrollHeight = searchResultsWrapperElement.scrollHeight - (searchResultsWrapperElement.offsetHeight || searchResultsWrapperElement.clientHeight);
            scrollToPositionValue = maxScrollHeight;
          } else if (this.searchedDestinationFocusIndex === 0) {
            // If focusedHotelItem is the first item, scroll to the beginning
            scrollToPositionValue = 0;
          } else {
            // Else scroll based on the focusedHotelItem's size (height)
            scrollToPositionValue = direction === 'down' ? Math.ceil(searchResultsWrapperElement.scrollTop + focusedHotelItem.offsetHeight) : Math.floor(searchResultsWrapperElement.scrollTop - focusedHotelItem.offsetHeight);
            // If a header needs to be skipped then scroll further
            if (direction === 'down' && focusedHotelItem.previousElementSibling && focusedHotelItem.previousElementSibling.classList.contains('result-item-heading')) {
              scrollToPositionValue = Math.ceil(scrollToPositionValue + focusedHotelItem.previousElementSibling.offsetHeight) + 10;
            } else if (direction === 'up' && focusedHotelItem.nextElementSibling && focusedHotelItem.nextElementSibling.classList.contains('result-item-heading')) {
              scrollToPositionValue = Math.floor(scrollToPositionValue - focusedHotelItem.nextElementSibling.offsetHeight) - 10;
              if (scrollToPositionValue < 0) {
                scrollToPositionValue = 0;
              }
            }
          }
          requestAnimationFrame(() => this.scrollToPosition(searchResultsWrapperElement, scrollToPositionValue, direction));
        }
      }
    });
  }

  scrollToPosition(scrollContainerElement, position: number, direction: 'up' | 'down') {
    const scrollSpeed = 9;
    if (direction === 'down') {
      if ((scrollContainerElement.scrollTop + scrollSpeed) < position) {
        scrollContainerElement.scrollTop = scrollContainerElement.scrollTop + scrollSpeed;
        if (scrollContainerElement.scrollTop < position) {
          requestAnimationFrame(() => this.scrollToPosition(scrollContainerElement, position, direction));
        } else {
          scrollContainerElement.scrollTop = position;
        }
      } else {
        scrollContainerElement.scrollTop = position;
      }
    } else {
      if ((scrollContainerElement.scrollTop - scrollSpeed) > position) {
        scrollContainerElement.scrollTop = scrollContainerElement.scrollTop - scrollSpeed;
        if (scrollContainerElement.scrollTop > position) {
          requestAnimationFrame(() => this.scrollToPosition(scrollContainerElement, position, direction));
        } else {
          scrollContainerElement.scrollTop = position;
        }
      } else {
        scrollContainerElement.scrollTop = position;
      }
    }
  }

  deselectDestination() {
    this.airport = '';
    this.clear();
    setTimeout(() => this.isDestination = true);
  }

  clear() {
    this.searchFormControl.setValue('');
    this.reset();
  }

  onDestinationClicked(airport) {
    if (!airport) {
      return;
    }
    let event = {
      name: airport.name,
      codes: airport.codes
    };
    this.searchFormControl.setValue(airport.name);
    this.airportSelected.emit(event);
    this.isDestination = false;
  }

  reset() {
    setTimeout(() => {
      this.searchedDestinations = [...this.airports];
    });
  }

  dismissResultsPopover() {
    if (!this.airport) {
      this.clear();
    }
    setTimeout(() => {
      this.isDestination = false;
      // this.showDropdown = false;
    });
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    if (!this.searchResultsWrapper || !this.searchResultsWrapper.nativeElement || !this.searchInput) {
      return;
    }
    const clickedInside = this.searchResultsWrapper.nativeElement.contains(targetElement) || this.searchInput.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.dismissResultsPopover();
    }
  }
}
